<template>
  <v-dialog
    ref="dialog"
    :value="open"
    content-class="homeLayoutDialog"
    max-width="495px"
    :persistent="true"
    @click:outside="handleOutside"
  >
    <v-btn
      icon
      class="homeLayoutDialog-closeIcon"
      tabindex="-1"
      @click="handleClose"
    >
      <v-icon color="darken-2"> mdi-close </v-icon>
    </v-btn>
    <header>
      <h2>表示カメラ選択</h2>
      <h4>ドラッグアンドドロップで並び替えをしてください</h4>
    </header>

    <home-layout
      v-if="open"
      ref="layout"
      :dialog-ref="$refs.dialog"
      @save="handleSave"
      @cancel="handleCancel"
    />
  </v-dialog>
</template>

<script>
import HomeLayout from '@/components/HomeLayout.vue';

export default {
  name: 'HomeLayoutDialog',
  components: {
    HomeLayout,
  },
  props: {
    open: {
      type: Boolean,
    },
    message: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    handleOutside(e) {
      e.preventDefault();
      e.stopPropagation();
      this.handleClose();
    },
    handleSave() {
      this.handleClose();
    },
    handleCancel() {
      this.handleClose();
    },
    handleClose() {
      this.$emit('onClose');
    },
  },
};
</script>

<style lang="scss">
.homeLayoutDialog {
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  position: relative;
  overflow-x: hidden;
  &.v-dialog:not(.v-dialog--fullscreen) {
    max-height: calc(100% - 60px);
    overflow-y: hidden;
  }
  &-closeIcon {
    &.v-btn {
      &.v-btn--icon.v-size--default {
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 1;
      }

      .v-icon {
        margin-right: 0;
        font-size: 20px;
        color: #999;
        font-weight: bold;
      }

      &:not(.v-btn--text):not(.v-btn--outlined):hover:before,
      &.theme--light:hover::before {
        opacity: 0;
      }
    }
  }
  & > header {
    margin-top: 32px;
    margin-left: 30px;
    margin-bottom: 10px;
    h2 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
      margin-bottom: 10px;
    }
    h4 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
  }
}
</style>
